<template>
  <div class="card mb-25 border-0 rounded-0 bg-white add-user-card">
    <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
      <Form @submit="addValidationQueue" :validation-schema="validationQueueSchema" :initial-values="initialValues">
        <div class="row">
          <div class="col-12 mb-3">
            <h6 class="text-primary fw-semibold border-bottom pb-2">
              <i class="ri-information-line"></i> Informations générales
            </h6>
          </div>
          <div class="col-md-6">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Code <span class="text-danger">*</span>
              </label>
              <Field name="code" type="text" class="form-control shadow-none fs-md-15 text-black"
                placeholder="Entrez le code " />
              <ErrorMessage name="code" class="text-danger" />
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Libellé de la file <span class="text-danger">*</span>
              </label>
              <Field name="name" type="text" class="form-control shadow-none fs-md-15 text-black" placeholder="" />
              <ErrorMessage name="name" class="text-danger" />
            </div>
          </div>
          <div class="col-md-12">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Description <span class="text-danger">*</span>
              </label>
              <Field name="description" as="textarea" class="form-control shadow-none fs-md-15 text-black" />
              <ErrorMessage name="description" class="text-danger" />
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Niveau de risque minimal des dossiers acceptés <span class="text-danger">*</span>
              </label>
              <Field name="minRiskLevel" v-slot="{ field }">
                <Multiselect :options="minRiskOptions" :searchable="true" multiple="false" track-by="label"
                  label="label" v-model="selectedMinRisk" v-bind="field"
                  placeholder="Sélectionner le niveau de risque" />
              </Field>
              <ErrorMessage name="minRiskLevel" class="text-danger" />
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Niveau de risque maximal des dossiers acceptés <span class="text-danger">*</span>
              </label>
              <Field name="maxRiskLevel" v-slot="{ field }">
                <Multiselect :options="maxRiskOptions" :searchable="true" multiple="false" track-by="label"
                  label="label" v-model="selectedMaxRisk" v-bind="field"
                  placeholder="Sélectionner le niveau de risque" />
              </Field>
              <ErrorMessage name="maxRiskLevel" class="text-danger" />
            </div>
          </div>
          <!-- <div class="col-md-6">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Port <span class="text-danger">*</span>
              </label>
              <Field name="port" v-slot="{ field }">
                <Multiselect :options="portOptions" :searchable="true" multiple="false" track-by="label" label="label"
                  v-model="field.value" v-bind="field" placeholder="Sélectionner le port" />
              </Field>
              <ErrorMessage name="port" class="text-danger" />
            </div>
          </div> -->

          <div class="col-md-6">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Port
              </label>
              <Field name="port" v-slot="{ field }">
                <Multiselect v-model="field.value" v-bind="field" :options="ports" :searchable="true"
                  :loading="loadingPorts" placeholder="Rechercher (nomPort ou locode)..." label="label" track-by="value"
                  @search-change="searchPort" :filter-results="false" :min-chars="2" />
              </Field>
              <ErrorMessage name="port" class="text-danger" />
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Pays 
              </label>
              <Field name="pays" v-slot="{ field }">
                <Multiselect :options="paysOptions" :searchable="true" multiple="false" track-by="label" label="label"
                  v-model="field.value" v-bind="field" placeholder="Sélectionner le pays " />
              </Field>
              <ErrorMessage name="pays" class="text-danger" />
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                File par defaut <span class="text-danger">*</span>
              </label>
              <Field name="isActive" type="checkbox" :value="true" :unchecked-value="true" v-slot="{ field }">
                <div class="form-check">
                  <input type="checkbox" class="form-check-input" v-bind="field" />
                  <label class="form-check-label ms-2">Oui</label>
                </div>
              </Field>
              <!-- <ErrorMessage name="isActive" class="text-danger" /> -->
            </div>
          </div>
          <div class="col-md-12">
            <div class="d-flex align-items-center ">
              <button
                class="default-btn me-20 transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16 bg-success"
                type="submit">
                Valider
              </button>
              <router-link to="/listevalidationqueue" class=" btn btn-danger transition border-0 lh-1 fw-medium"><i
                  class="flaticon-delete lh-1 me-1 position-relative top-2"></i>
                <span class="position-relative"></span>Annuler</router-link>
            </div>
          </div>
        </div>
      </Form>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref, watch } from 'vue';
import { Form, Field, ErrorMessage } from 'vee-validate';
import ApiService from '../../services/ApiService';
import * as Yup from 'yup';
import { error, success, hideModal } from '../../utils/utils';
import { TypeFretPaiement } from '@/models/TypeFretPaiement';
import { Modal } from 'bootstrap';
import Multiselect from '@vueform/multiselect'
import { ValidationQueues } from '@/models/ValidationTask';
import router from '@/router';

export default defineComponent({
  name: "AddModalValidationQueue",
  components: {
    Form,
    Field,
    ErrorMessage,
    Multiselect

  },
  props: {
    item: {
      type: Number,
      default: 0,
    }
  },
  setup(props, { emit }) {
    const validationQueueSchema = Yup.object().shape({
      code: Yup.string().required('Le code est obligatoire'),
      name: Yup.string().required('Le champ name est obligatoire'),
      description: Yup.string().required('Ce champ est obligatoire'),
      pays: Yup.string().nullable(),
      port: Yup.string().nullable(),

    });


    const validationQueueForm = ref<ValidationQueues | null>(null);
    const addModalValidationQueueRef = ref<null | HTMLElement>(null);
    const localItem = ref(props.item);
    const isUPDATE = ref(false);
    const title = ref("Ajouter une validation Queue");
    const btntext = ref('Ajouter');
    const portOptions = ref([])
    const ports = ref<{ value: number; label: string }[]>([]);
    const loadingPorts = ref(false);
    let searchTimeout: ReturnType<typeof setTimeout> | null = null;
    const paysOptions = ref([])
    const maxRiskOptions = [
      { value: 'LOW', label: 'Faible' },
      { value: 'MEDIUM', label: 'Moyen' },
      { value: 'HIGH', label: 'Elévé' },
    ]

    const minRiskOptions = [
      { value: 'LOW', label: 'Faible' },
      { value: 'MEDIUM', label: 'Moyen' },
      { value: 'HIGH', label: 'Elévé' },
    ]

    const initialValues = {
      isActive: true
    };

    const selectedMinRisk = ref<{ value: string; label: string } | null>(null);
    const selectedMaxRisk = ref<{ value: string; label: string } | null>(null);


    const fetchPays = async () => {
      try {
        const response = await ApiService.get('/pays');
        const paysData = response.data.data.data;
        paysOptions.value = paysData.map((pays) => ({
          value: pays.id,
          label: `${pays.iso2_code} ${pays.iso3_code} ${pays.name_fr} ${pays.name_en}`
        }))
      } catch (error) {
        //
      }
    }

    const searchPort = async (query: string) => {
      if (searchTimeout) clearTimeout(searchTimeout);

      if (!query || query.length < 2) {
        ports.value = [];
        return;
      }

      searchTimeout = setTimeout(async () => {
        loadingPorts.value = true;
        try {
          const response = await ApiService.get(
            `/Liste/port?search=${encodeURIComponent(query)}`
          );
          const portsData = response.data?.data || [];

          ports.value = portsData.map((port: any) => ({
            label: `${port.nomPort} - ${port.locode}`,
            value: port.id,
          }));
        } catch (err) {
          console.error('Erreur recherche ports:', err);
          ports.value = [];
        } finally {
          loadingPorts.value = false;
        }
      }, 300);
    };


    const addValidationQueue = async (values: any, validationQueueForm) => {
      values = values as ValidationQueues;
      const token = localStorage.getItem('id_token');
      if (!token) {
        console.log("Aucun token trouvé dans le localStorage");
        return error("Utilisateur non connecté");
      }
      console.log("Token envoyé au backend:", token);
      console.log("Valeurs envoyées:", values);
      delete values.userId;
      ApiService.post("/validationq", values)
        .then(({ data }) => {
          if (data.code == 201) {
            success(data.message);
            validationQueueForm.resetForm();
            router.push({ name: "ListeValidationQueuePage" })
          }
        })
        .catch(({ response }) => {
          error(response.data.message);
        });

    };



    onMounted(() => {
      // fetchPort();
      fetchPays();
    })

    return {
      validationQueueForm,
      addModalValidationQueueRef,
      addValidationQueue,
      validationQueueSchema,
      title, btntext,
      paysOptions,
      maxRiskOptions,
      minRiskOptions,
      selectedMinRisk,
      selectedMaxRisk,
      searchPort,
      ports,
      loadingPorts,
      initialValues

    };
  },
});
</script>